import * as React from 'react';

import EmptyImages from './icons/EmptyImages.svg';
import * as styles from './Stub.css';
import { Image } from '@cian/ui-kit';

export const Stub = (): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <Image width={36} height={36} src={EmptyImages} />
    </div>
  );
};
